<template>
  <div ref="elRef" :id="id" :class="className" :style="{ height, width }" />
</template>

<script setup lang="ts">
// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import { ref, watch, onMounted, onBeforeUnmount } from 'vue'
import * as echarts from 'echarts'
import type { ECharts, EChartsOption } from 'echarts'

defineOptions({ name: 'Echart' })

const props = withDefaults(
  defineProps<{
    className?: string
    id?: string
    width?: string
    height?: string
    options?: EChartsOption | Record<string, unknown>
  }>(),
  {
    className: 'chart',
    id: 'chart',
    width: '100%',
    height: '100%',
    options: () => ({}),
  },
)

const elRef = ref<HTMLElement | null>(null)
const chart = ref<ECharts | null>(null)

const initChart = () => {
  if (!elRef.value) return
  chart.value = echarts.init(elRef.value)
  chart.value.setOption(props.options as EChartsOption, true)
}

watch(
  () => props.options,
  (options) => {
    if (chart.value) {
      chart.value.setOption(options as EChartsOption, true)
    }
  },
  { deep: true },
)

onMounted(() => {
  initChart()
})

onBeforeUnmount(() => {
  chart.value?.dispose()
  chart.value = null
})

/** 供父组件 this.$refs.xxx.chart 访问 */
defineExpose({
  get chart() {
    return chart.value
  },
})
</script>

<style>
</style>
